import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
//**
//  The window.addEventListener('offline/online') functions do not fire on Firefox
//  As a workaround we detect ourselves when we are offline (if an upload fails, check if navigator.onLine is false)
//  Start polling until back online
//  Since we can't do much else anyways without a connection, this is a low cost solution
//  */
export class ShConnectionService {
    private readonly isOnline$: BehaviorSubject<boolean> = new BehaviorSubject(true);

    constructor() {
        this.isOnline$
            .pipe(
                distinctUntilChanged(),
                filter(isOnline => !isOnline)
            )
            .subscribe(() => {
                const poller = setInterval(() => {
                    if (navigator.onLine) {
                        clearInterval(poller);
                        this.isOnline$.next(true);
                    }
                }, 1000);
            });
    }

    public isOnline(): Observable<boolean> {
        return this.isOnline$;
    }

    public notifyOffline(): void {
        this.isOnline$.next(false);
    }
}
